<mat-card class="contenedor-templates">

  <ngx-spinner [zIndex]="100" name="spTemplatesBanco" bdColor="rgba(255,255,255,0.8)" size="default" color="#009688"
    type="ball-atom" [fullScreen]="false"></ngx-spinner>

  <div class="row">

    <!-- Templates existentes -->
    <div class="col-12 col-lg-3 panel-lista">
      <div class="titulo-lista">
        <span><mat-icon>account_balance</mat-icon> Bancos</span>
        <button mat-icon-button color="primary" matTooltip="Nuevo template" (click)="nuevoTemplate()">
          <mat-icon>add</mat-icon>
        </button>
      </div>

      <mat-nav-list>
        <a mat-list-item *ngFor="let t of templates; trackBy: trackByItems" (click)="seleccionarTemplate(t)"
          [class.activo]="templateSeleccionado && templateSeleccionado.id === t.id">
          <div class="item-template">
            <strong>{{ t.banco ? t.banco.descripcion : 'Sin banco' }}</strong>
            <span class="detalle-item">{{ t.descripcion }}</span>
            <span class="detalle-item">{{ t.detallesTemplateBanco?.length || 0 }} campos</span>
          </div>
        </a>
      </mat-nav-list>

      <p class="sin-templates" *ngIf="templates.length === 0">
        No hay templates cargados todavía.
      </p>
    </div>

    <!-- Edición -->
    <div class="col-12 col-lg-9" *ngIf="templateSeleccionado">

      <form [formGroup]="form">
        <div class="row">
          <div class="col-12 col-md-6 col-lg-3">
            <mat-form-field class="full-width">
              <mat-label>Banco</mat-label>
              <mat-select formControlName="IdBanco">
                <mat-option [value]="banco.id" *ngFor="let banco of lstBancos; trackBy: trackByItems">
                  {{ banco.descripcion }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-12 col-md-6 col-lg-4">
            <mat-form-field class="full-width">
              <mat-label>Descripción</mat-label>
              <input matInput formControlName="Descripcion">
            </mat-form-field>
          </div>

          <div class="col-12 col-md-6 col-lg-3">
            <mat-form-field class="full-width">
              <mat-label>Nombre de archivo</mat-label>
              <input matInput formControlName="NombreArchivo">
              <mat-hint>Usá FECHAHORAMINUTOSEGUNDO donde vaya la fecha</mat-hint>
            </mat-form-field>
          </div>

          <div class="col-12 col-md-6 col-lg-2">
            <mat-form-field class="full-width">
              <mat-label>Extensión</mat-label>
              <input matInput formControlName="ExtensionArchivo">
            </mat-form-field>
          </div>
        </div>
      </form>

      <!-- Control de ancho -->
      <div class="control-ancho" [class.error]="!anchosCoinciden()">
        <mat-icon>{{ anchosCoinciden() ? 'check_circle' : 'error_outline' }}</mat-icon>
        <span>
          Ancho del renglón de detalle: <b>{{ getLargoDetalle() }}</b>
          &nbsp;·&nbsp;
          Ancho del pie: <b>{{ getLargoPie() }}</b>
        </span>
        <span class="aviso" *ngIf="!anchosCoinciden()">
          Todas las líneas del archivo tienen que medir lo mismo. Agregá un campo de relleno al pie.
        </span>
      </div>

      <!-- Campos del detalle -->
      <h3 class="titulo-seccion">
        <mat-icon>list</mat-icon> Campos del detalle
        <button mat-stroked-button color="primary" (click)="agregarCampo(false)">
          <mat-icon>add</mat-icon> Agregar campo
        </button>
      </h3>

      <ng-container *ngTemplateOutlet="tablaCampos; context: { origen: dataSourceDetalle, esPie: false }">
      </ng-container>

      <!-- Campos del pie -->
      <h3 class="titulo-seccion">
        <mat-icon>playlist_add_check</mat-icon> Campos del pie
        <button mat-stroked-button color="primary" (click)="agregarCampo(true)">
          <mat-icon>add</mat-icon> Agregar campo
        </button>
      </h3>

      <p class="nota-pie">
        El pie es la última línea del archivo. <b>TotalImporte</b> y <b>CuentaRegistro</b> los calcula
        el sistema; la cantidad incluye al propio pie.
      </p>

      <ng-container *ngTemplateOutlet="tablaCampos; context: { origen: dataSourcePie, esPie: true }">
      </ng-container>

      <div class="acciones">
        <button mat-raised-button color="primary" (click)="guardar()">
          <mat-icon>save</mat-icon> Guardar template
        </button>
      </div>
    </div>

    <div class="col-12 col-lg-9 sin-seleccion" *ngIf="!templateSeleccionado">
      <mat-icon>touch_app</mat-icon>
      <p>Elegí un banco de la lista o creá un template nuevo.</p>
    </div>
  </div>

  <!-- Tabla de campos, compartida entre detalle y pie -->
  <ng-template #tablaCampos let-origen="origen" let-esPie="esPie">
    <div class="tabla-container">
      <table mat-table [dataSource]="origen" class="tabla-campos">

        <ng-container matColumnDef="orden">
          <th mat-header-cell *matHeaderCellDef class="col-orden">Orden</th>
          <td mat-cell *matCellDef="let campo; let i = index" class="col-orden">
            <span class="numero-orden">{{ i + 1 }}</span>
            <button mat-icon-button (click)="mover(campo, esPie, -1)" [disabled]="i === 0" matTooltip="Subir">
              <mat-icon>arrow_upward</mat-icon>
            </button>
            <button mat-icon-button (click)="mover(campo, esPie, 1)"
              [disabled]="i === origen.data.length - 1" matTooltip="Bajar">
              <mat-icon>arrow_downward</mat-icon>
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="nombreCampo">
          <th mat-header-cell *matHeaderCellDef>Campo</th>
          <td mat-cell *matCellDef="let campo">
            <mat-form-field class="campo-tabla">
              <mat-select [(value)]="campo.nombreCampo">
                <mat-option *ngFor="let nombre of camposDisponibles; trackBy: trackByItems" [value]="nombre">
                  {{ nombre }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </td>
        </ng-container>

        <ng-container matColumnDef="largo">
          <th mat-header-cell *matHeaderCellDef class="col-largo">Largo</th>
          <td mat-cell *matCellDef="let campo" class="col-largo">
            <mat-form-field class="campo-tabla">
              <input matInput type="number" min="1" [(ngModel)]="campo.largoCampo"
                [ngModelOptions]="{ standalone: true }">
            </mat-form-field>
          </td>
        </ng-container>

        <ng-container matColumnDef="tipo">
          <th mat-header-cell *matHeaderCellDef>Tipo</th>
          <td mat-cell *matCellDef="let campo">
            <mat-checkbox [(ngModel)]="campo.esNumerico" [ngModelOptions]="{ standalone: true }"
              (change)="onCambiaTipo(campo)" matTooltip="Numérico">
              Num.
            </mat-checkbox>
            <mat-checkbox [(ngModel)]="campo.completaConCeros" [ngModelOptions]="{ standalone: true }"
              [disabled]="!campo.esNumerico" matTooltip="Rellenar con ceros en vez de espacios">
              Ceros
            </mat-checkbox>
            <mat-checkbox [(ngModel)]="campo.sinEspacios" [ngModelOptions]="{ standalone: true }"
              matTooltip="Quitar espacios antes de formatear">
              Trim
            </mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="alineacion">
          <th mat-header-cell *matHeaderCellDef>Alineación</th>
          <td mat-cell *matCellDef="let campo">
            <mat-radio-group>
              <mat-radio-button [checked]="campo.alineacionIzq" (change)="onCambiaAlineacion(campo, true)">
                Izq.
              </mat-radio-button>
              <mat-radio-button [checked]="campo.alineacionDer" (change)="onCambiaAlineacion(campo, false)">
                Der.
              </mat-radio-button>
            </mat-radio-group>
          </td>
        </ng-container>

        <ng-container matColumnDef="decimales">
          <th mat-header-cell *matHeaderCellDef class="col-largo">Dec.</th>
          <td mat-cell *matCellDef="let campo" class="col-largo">
            <mat-form-field class="campo-tabla">
              <input matInput type="number" min="0" max="4" [(ngModel)]="campo.cantidadDecimales"
                [ngModelOptions]="{ standalone: true }" [disabled]="!campo.esNumerico">
            </mat-form-field>
          </td>
        </ng-container>

        <ng-container matColumnDef="valorPorDefecto">
          <th mat-header-cell *matHeaderCellDef>Valor por defecto</th>
          <td mat-cell *matCellDef="let campo">
            <mat-form-field class="campo-tabla">
              <input matInput [(ngModel)]="campo.valorPorDefecto" [ngModelOptions]="{ standalone: true }"
                placeholder="opcional">
            </mat-form-field>
          </td>
        </ng-container>

        <ng-container matColumnDef="accion">
          <th mat-header-cell *matHeaderCellDef class="col-accion">&nbsp;</th>
          <td mat-cell *matCellDef="let campo" class="col-accion">
            <button mat-icon-button color="warn" (click)="quitarCampo(campo, esPie)" matTooltip="Quitar campo">
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columnas"></tr>
        <tr mat-row *matRowDef="let fila; columns: columnas"></tr>
      </table>

      <p class="sin-campos" *ngIf="origen.data.length === 0">
        Sin campos. Usá "Agregar campo".
      </p>
    </div>
  </ng-template>

</mat-card>
